export const PEAK_RADIX = 36;
export const PEAK_RATE = 25; // per second

export function lossyEncodePeaks(rawPeaks) {
  if (!rawPeaks.length) return "";
  rawPeaks = rawPeaks.map((m) => Math.abs(m));
  const max = rawPeaks.reduce((a, b) => Math.max(a, b));
  const quant = rawPeaks.map((p) => Math.round(((PEAK_RADIX - 1) * p) / max));
  return quant.map((q) => q.toString(PEAK_RADIX)).join("");
}

export function decodePeaks(str) {
  return str.split("").map((s) => Number.parseInt(s, PEAK_RADIX));
}
